import React from 'react';
import ReusableTabs from '../../../pages/ReusableTabs';
import DamagedForm from './DamagedForm';
import DamagedAnalysis from './DamagedAnalysis';
 
const DamagedModuleTabsComponent = () => {
  const tabs = [
    { label: 'Damaged Modules Form', component: <DamagedForm /> },
    { label: 'Damaged Modules Analysis', component: <DamagedAnalysis /> },
  ];
 
  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={0}
      panelStyles={{ padding: '16px' }}
    />
  );
};
 
export default DamagedModuleTabsComponent;